import React from "react";
import "containers/ProjectCommon.css";
import "containers/Projects/StartProject/Step_3/StartProjectStepThree.css";
import AxiosConfig from "axiosConfig";
import UnregisteredFriendsInvite from "components/Project/StartProject/Step_3/UnregisteredFriendsInvite";
import TwoButtonLayout from "components/General/Form/CustomButton/TwoButtonLayout";
import TextTheme from "components/General/Text/TextTheme";
import * as FriendsSearchHelper from "components/Project/FriendsSearcHelper/FriendsSearchHelper";
import VerticalSpotlightDetails from "components/Spotlight/VerticalSpotlightDetails";
import "./MyFriends.css";
import TextArea from "components/General/Form/TextArea";

class BuildYourTeam extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inviteMessage: "Hello Friends",
      unregisteredUser: [
        { email_address: "", issue: null, status: null },
        { email_address: "", issue: null, status: null },
        { email_address: "", issue: null, status: null },
        { email_address: "", issue: null, status: null },
        { email_address: "", issue: null, status: null },
      ],
      unregisteredUserIssue: "",
      sendInvitationIssue: "",
    };
  }

  sendInviteButtonClick() {
    if (
      this.checkUnregisteredUsersErr() === false
      &&
      this.checkInvitationMessageErr() === false
    ) {
      this.setState({ sendInvitationIssue: "" });
      this.sendInvitationToUsers(this);
    }
  }

  checkInvitationMessageErr() {
    if (this.state.inviteMessage.length === 0) {
      this.setState({
        sendInvitationIssue:
          "Enter an Invitation message to be sent to your invitee's.",
      });
      return true;
    }
    return false;
  }

  checkUnregisteredUsersErr() {
    let errorFlag = false;
    let duplicateEmail = false;
    for (let i = 0; i < this.state.unregisteredUser.length; i++) {
      // nested for loop
      for (let j = 0; j < this.state.unregisteredUser.length; j++) {
        // prevents the element from comparing with itself
        if (i !== j) {
          // check if elements' values are equal
          if (
            this.state.unregisteredUser[i].email_address ===
            this.state.unregisteredUser[j].email_address
          ) {
            // duplicate element present
            duplicateEmail = true;
            // terminate inner loop
            break;
          }
        }
      }
    }
    if (duplicateEmail) {
      errorFlag = true;
      this.setState({
        sendInvitationIssue: "Duplicate emails found",
      });
    }
    for (let i = 0; i < this.state.unregisteredUser.length; i++) {
      if (this.state.unregisteredUser[i]["issue"] == null) {
        errorFlag = true;
        this.setState({
          sendInvitationIssue:
            "Please provide atleast one valid email address and remove the blank fields if any",
        });
        break;
      } else if (this.state.unregisteredUser[i]["issue"].trim().length !== 0) {
        errorFlag = true;
        this.setState({
          sendInvitationIssue:
            "Please provide atleast one valid email address and remove the blank fields if any",
        });
        break;
      }
    }

    return errorFlag;
  }

  sendInvitationToUsers(obj) {
    let form_data = new FormData();
    for (let i = 0; i < this.state.unregisteredUser.length; i++) {
      form_data.append(
        "unregistered_user",
        this.state.unregisteredUser[i]["email_address"].trim()
      );
    }
    form_data.append("invitation_message", this.state.inviteMessage);
    if (this.props.match.params.groupId == undefined) {
      AxiosConfig.post(`/friends/invite_new_friend/`, form_data)
        .then((response) => {
          const invitationResult = response.data.invitation_result;
          let unregisteredUser = this.state.unregisteredUser;
          for (let i = 0; i < invitationResult.length; i++) {
            unregisteredUser[i].status = invitationResult[i].status;
          }
          this.setState({ unregisteredUser });
          if (response.data.status === "SUCCESS") {
            setTimeout(() => {
              this.setState({
                unregisteredUser: [
                  { email_address: "", issue: null, status: null },
                  { email_address: "", issue: null, status: null },
                  { email_address: "", issue: null, status: null },
                  { email_address: "", issue: null, status: null },
                  { email_address: "", issue: null, status: null },
                ],
                inviteMessage: "Hello Friends"
              });
            }, 2500)
          }
        })
        .catch(function (error) { });
    } else {
      form_data.append("groupId", this.props.match.params.groupId);
      AxiosConfig.post(`/groups/invite_new_friend/`, form_data)
        .then((response) => {
          const invitationResult = response.data.invitation_result;
          let unregisteredUser = this.state.unregisteredUser;
          for (let i = 0; i < invitationResult.length; i++) {
            unregisteredUser[i].status = invitationResult[i].status;
          }
          this.setState({ unregisteredUser });
          if (response.data.status === "SUCCESS") {
            setTimeout(() => {
              this.setState({
                unregisteredUser: [
                  { email_address: "", issue: null, status: null },
                  { email_address: "", issue: null, status: null },
                  { email_address: "", issue: null, status: null },
                  { email_address: "", issue: null, status: null },
                  { email_address: "", issue: null, status: null },
                ],
                inviteMessage: "Hello Friends"
              });
            }, 2500)
          }
        })
        .catch(function (error) { });
    }
  }

  render() {
    return (
      <div className="header_main">
        <div className="page_main">
          <div id="vertical_spotlight_details">
            <VerticalSpotlightDetails isSpotlightPage={false} />
          </div>

          <div className="page_details_main tribe">
            <div className="page_details_content_main invite-friends">
              <span className="textHeader">Invite a Friend</span>
              <UnregisteredFriendsInvite
                message="Send invites to unregistered users"
                unregisteredUser={this.state.unregisteredUser}
                unregisteredUserIssue={this.state.unregisteredUserIssue}
                unregisteredUserAddMoreClick={FriendsSearchHelper.unregisteredUserAddMore.bind(
                  this
                )}
                unregisteredUserEmailChange={FriendsSearchHelper.unregisteredUserEmailChangeFriends.bind(
                  this
                )}
                unregisteredUserDeleteClick={FriendsSearchHelper.unregisteredUserDeleteClick.bind(
                  this
                )}
                unregisteredUserEmailValidate={FriendsSearchHelper.unregisteredUserEmailValidate.bind(
                  this
                )}
                disabled={false}
              />
              <hr />
              <div style={{ marginTop: "20px" }}>
                <div>
                  <TextTheme
                    message="Invitation message to friends *"
                    className="text_small text_black"
                  />
                </div>
                <TextArea
                  value={this.state.inviteMessage}
                  rows={5}
                  handleChange={FriendsSearchHelper.inviteMessageChange.bind(
                    this
                  )}
                />
              </div>
              <div className="mb-15">
                <TwoButtonLayout
                  button1Text="QUIT"
                  button2Text="SEND INVITATIONS"
                  button1Click={() => window.history.back()}
                  button2Click={this.sendInviteButtonClick.bind(this)}
                  disabled={false}
                />
              </div>
              <TextTheme
                message={this.state.sendInvitationIssue}
                className="mt-15 text_small text_red text-center"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BuildYourTeam;
